var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "x_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M24.137.75v22.5h-22.5V.75z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.849 19.785 4.95-7.03-5.921-9.483h4.695l3.723 5.967 4.186-5.967h1.503l-4.995 7.1 5.897 9.413h-4.695l-3.677-5.874-4.163 5.874zm10.014-1.225h1.827L9.902 4.498H8.075z"
  }))));
};
export default SvgX;